<template>
  <div class="field">
    <label class="label" v-if="label !== ''">{{ label }}</label>
    <div class="control">
      <span
        v-if="offText !== ''"
        @click="$emit('input', (onText === '' ? !value : false))"
      >{{ offText }}</span>
      <label class="switch" :class="{'is-xs': xs, 'disabled': !edit}">
        <input type="checkbox" :id="id" :checked="value" @input="handleInput" />
        <span class="slider"></span>
      </label>
      <span
        v-if="onText !== ''"
        @click="$emit('input', (offText === '' ? !value : true))"
      >{{ onText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'switchButton',
  props: {
    value: {
      type: Boolean
    },
    offText: {
      type: String,
      default: ''
    },
    offValue: {
      type: String,
      default: ''
    },
    onText: {
      type: String,
      default: ''
    },
    onValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String
    },
    xs: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      content: this.value
    }
  },
  methods: {
    handleInput (e) {
      var value = e.target.checked
      // if (this.offValue !== '' && this.onValue !== '') {
      //   if (value) {
      //     value = this.onValue
      //   } else {
      //     value = this.offValue
      //   }
      // }
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.control {
  > span {
    cursor: pointer;
    display: inline-block;

    &:first-child{
      text-align: right;
    }
  }
  .switch {
    $i: 2px;
    $h: 18px;

    position: relative;
    display: inline-block;
    width: calc((#{$h} * 2) - (#{$i} * 2));
    height: $h;
    margin-right: 6px;

    &.disabled {
      pointer-events: none;
    }

    &:not(:first-child) {
      margin-left: 6px;
    }

    input {
      opacity: 0;
      width: 0;
      height: 0;

      &:checked + .slider {
        background-color: $success;

        &:before {
          -webkit-transform: translateX(calc(#{$h} - (#{$i} * 2)));
          -ms-transform: translateX(calc(#{$h} - (#{$i} * 2)));
          transform: translateX(calc(#{$h} - (#{$i} * 2)));
        }
      }
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 2px;
      left: 0;
      right: 0;
      bottom: -2px;
      background-color: $grey-lighter;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: calc(#{$h} * 2);

      &:before {
        position: absolute;
        content: "";
        height: calc(#{$h} - (#{$i} * 2));
        width: calc(#{$h} - (#{$i} * 2));
        left: $i;
        bottom: $i;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
      }
    }

    &.is-xs {
      $i: 1px;
      $h: 10px;

      width: calc((#{$h} * 2) - (#{$i} * 2));
      height: $h;

      input {
        &:checked + .slider {
          &:before {
            -webkit-transform: translateX(calc(#{$h} - (#{$i} * 2)));
            -ms-transform: translateX(calc(#{$h} - (#{$i} * 2)));
            transform: translateX(calc(#{$h} - (#{$i} * 2)));
          }
        }
      }

      .slider {
        border-radius: calc(#{$h} * 2);

        &:before {
          height: calc(#{$h} - (#{$i} * 2));
          width: calc(#{$h} - (#{$i} * 2));
          left: $i;
          bottom: $i;
        }
      }
    }
  }
}
// $i: 2px;
// $h: 18px;

// .switch {
//   position: relative;
//   display: inline-block;
//   width: calc((18px * 2) - 4px);;
//   height: 18px;
//   margin-right: 6px;

//   &:not(:first-child){
//     margin-left: 6px;
//   }

//   input {
//     opacity: 0;
//     width: 0;
//     height: 0;

//     &:checked + .slider {
//       background-color: $success;

//       &:before {
//         -webkit-transform: translateX(calc(18px - 4px));
//         -ms-transform: translateX(calc(18px - 4px));
//         transform: translateX(calc(18px - 4px));
//       }
//     }
//   }

//   .slider {
//     position: absolute;
//     cursor: pointer;
//     top: 2px;
//     left: 0;
//     right: 0;
//     bottom: -2px;
//     background-color: $grey-lighter;
//     -webkit-transition: .4s;
//     transition: .4s;
//     border-radius: calc(18px * 2);

//     &:before {
//       position: absolute;
//       content: "";
//       height: calc(18px - 4px);
//       width: calc(18px - 4px);
//       left: 2px;
//       bottom: 2px;
//       background-color: white;
//       -webkit-transition: .4s;
//       transition: .4s;
//       border-radius: 50%;
//     }
//   }

//   &.is-xs{
//     width: calc((10px * 2) - 2px);;
//     height: 10px;
//   }
// }
</style>
